export const getCategoryI18nKey = category => {
  return `marketplace-ui-common.groupTags.category.${category}`;
};
export const getHubSpotFeatureGroupI18nKey = (key, isUngatedForContentHub = false) => {
  if (key === 'CMS' && isUngatedForContentHub) {
    return 'marketplace-ui-common.groupTags.hubspotFeatureGroups.CONTENT';
  }
  return `marketplace-ui-common.groupTags.hubspotFeatureGroups.${key}`;
};
export const getHubSpotFeatureI18nKey = key => {
  return `marketplace-ui-common.groupTags.hubspotFeature.${key}`;
};
export const getTierI18nKey = tier => {
  return `marketplace-ui-common.groupTags.tier.${tier}`;
};
export const getTierHubI18nKey = hub => {
  return `marketplace-ui-common.groupTags.tierHub.${hub}`;
};
export const getTierLevelI18nKey = level => {
  return `marketplace-ui-common.groupTags.tierLevel.${level}`;
};